import {
  CLEAR_PITCH_EDITOR_PAGE, UPDATE_ALL_FACETS_PITCH, LOAD_PITCH_EDITOR_PAGE, UPDATE_FACET_PITCH, UPDATE_PITCH_STATUS,
} from 'constants/ActionTypes';

export const loadPitchEditorPage = (reportId) => ({ type: LOAD_PITCH_EDITOR_PAGE, reportId });

export const updateFacetPitch = (facetId, value) => ({ type: UPDATE_FACET_PITCH, facetId, value });

export const updateAllFacetsPitch = (value) => ({ type: UPDATE_ALL_FACETS_PITCH, value });

export const clearPitchEditorPage = () => ({ type: CLEAR_PITCH_EDITOR_PAGE });

export const updatePitchStatus = (editPitchStatus, updatedReportFileId) => ({ type: UPDATE_PITCH_STATUS, editPitchStatus, updatedReportFileId });
